<template>
    <div class="termpage">
        <div class="loading" v-if="loading">
            <v-progress-circular indeterminate color="#de5d0a"></v-progress-circular>
        </div>
        <div v-else class="term">
            <div class="containers contan">
                <div class="row mb-10">
                    <div class="col-lg-7 col-md-6 col-sm-12">
                        <div class="text_span">
                            <span class="font-khmer">{{ $t('message.TermCon') }}</span>
                        </div>
                        <ol>
                            <li class="main_text">{{ $t('message.tc1') }}</li>
                            <ul>
                                <li>{{ $t('message.tcd1') }}</li>
                                <li>{{ $t('message.tcd2') }}</li>
                            </ul>
                            <li class="main_text">{{ $t('message.tc2') }}</li>
                            <ul>
                                <li>{{ $t('message.tcd3') }}</li>
                                <li>{{ $t('message.tcd4') }}</li>
                            </ul>
                            <li class="main_text">{{ $t('message.tc3') }}</li>
                            <ul>
                                <li>{{ $t('message.tcd5') }}</li>
                                <li>{{ $t('message.tcd6') }}</li>
                                <li>{{ $t('message.tcd7') }}</li>
                                <li>{{ $t('message.tcd8') }}</li>
                            </ul>
                            <li class="main_text">{{ $t('message.tc4') }}</li>
                            <ul>
                                <li>{{ $t('message.tcd9') }}</li>
                                <li>{{ $t('message.tcd10') }}</li>
                            </ul>
                            <li class="main_text">{{ $t('message.tc5') }}</li>
                            <ul>
                                <li>{{ $t('message.tcd11') }}</li>
                                <li>{{ $t('message.tcd12') }}</li>
                                <li>{{ $t('message.tcd13') }}</li>
                                <li>Website: <a
                                        href="https://www.vireakbuntham.com/terms-and-conditions">{{ $t('message.tcd14') }}</a>
                                </li>
                                <li>{{ $t('message.tcd15') }}</li>
                            </ul>
                            <li class="main_text">{{ $t('message.tc6') }}</li>
                            <ul>
                                <li>{{ $t('message.tcd16') }}</li>
                                <li>{{ $t('message.tcd17') }}</li>
                            </ul>
                            <li class="main_text">{{ $t('message.tc7') }}</li>
                            <ul>
                                <li>{{ $t('message.tcd18') }}</li>
                                <li>{{ $t('message.tcd19') }}</li>
                                <li>{{ $t('message.tcd20') }}</li>
                                <li>{{ $t('message.tcd21') }}</li>
                                <li>{{ $t('message.tcd22') }}</li>
                                <li>{{ $t('message.tcd23') }}</li>
                                <li>{{ $t('message.tcd24') }}</li>
                            </ul>
                            <li class="main_text">{{ $t('message.tc8') }}</li>
                            <ul>
                                <li>{{ $t('message.tcd25') }}</li>
                                <li>{{ $t('message.tcd26') }}</li>
                            </ul>
                            <li class="main_text">{{ $t('message.tc9') }}</li>
                            <ul>
                                <li>{{ $t('message.tcd27') }}</li>
                                <li>{{ $t('message.tcd28') }}</li>
                            </ul>
                            <li class="main_text">{{ $t('message.tc10') }}</li>
                            <ul>
                                <li>{{ $t('message.tcd29') }}</li>
                                <li>{{ $t('message.tcd30') }}</li>
                                <li>{{ $t('message.tcd31') }}</li>
                                <li>{{ $t('message.tcd32') }}</li>
                            </ul>
                        </ol>
                        <!-- <ul>
                            <li class="above_text font-khmer">{{ $t('message.tc1') }}</li>
                            <li class="text_font font-khmer">{{ $t('message.tc2') }}</li>
                            <li class="text_font font-khmer">{{ $t('message.tc3') }}</li>
                            <li class="text_font font-khmer">{{ $t('message.tc4') }}</li>
                            <li class="text_font font-khmer">{{ $t('message.tc5') }}</li>
                            <li class="text_font font-khmer">{{ $t('message.tc6') }}</li>
                            <li class="text_font font-khmer">{{ $t('message.tc7') }}</li>
                            <li class="text_font font-khmer">{{ $t('message.tc8') }}</li>
                            <li class="text_font font-khmer">{{ $t('message.tc9') }}</li>
                            <li class="text_font font-khmer">{{ $t('message.tc10') }}</li>
                            <li class="text_font font-khmer">{{ $t('message.tc11') }}</li>

                        </ul> -->

                    </div>
                    <div class="col-lg-5 col-md-6 col-sm-12">
                        <div class="noted_img">
                            <img src="@/assets/terms/terms-and-conditions.svg" alt="">
                        </div>
                    </div>
                </div>
                <!-- <div class="row mb-10">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class="text_span">
                            <span>Terms &</span> <span style="color: #DE5D0A;"> Condition</span>
                        </div>
                        <ul>
                            <li class="above_text">Passengers are required to arrive at the boarding point 15 minutes before the scheduled departure time for check in.</li>
                            <li class="text_font">It is the passengers' responsibility to ensure early or on-time arrival at the boarding station. Missed schedules will not be eligible for refunds. The purchase tickets will be expired after the bus departure.</li>
                            <li class="text_font">Purchased tickets are non-refundable but can be used as a coupon for future trips. Coupon refunds can be processed up to 12 hours before departure schedule. The Coupon valid three months this reschedule can be made only time with the same route and vehicle type.</li>
                            <li class="text_font">For crossing border Vireak Buntham Express Travel is not responsible for VISA entry to the country, in case any immigration rejects at the border, passenger will not eligible for refund the ticket.</li>
                            <li class="text_font">Infants under the age of 3 are not required to have tickets. They must be accompanied by an adult and sit on their lap. Children aged 3 and above must purchase their own seats at the full price. But for sleeping bus infant require to have their bed.</li>
                            <li class="text_font">Passengers can choose their preferred seats and purchase real-time tickets through the VET Express Mobile APP or website at any time before schedule.</li>
                            <li class="text_font">Passengers are allowed a maximum of 25kg of checked baggage and one carry-on item. Additional charges will apply for overweight baggage, based on the local delivery fee.</li>
                            <li class="text_font">Items such as strong-smelling food (e.g., durian), pets, firearms, narcotics, smuggled or illegal products, and other dangerous or flammable/explosive items are strictly prohibited from being brought onboard.</li>
                            <li class="text_font">Passengers are responsible for the safety of their personal belongings and valuables. Vireak Buntham Express Travel will not be held liable for any loss or damage to personal items.</li>
                        </ul>
                        
                    </div>
                </div> -->
            </div>

        </div>
    </div>
</template>

<script>

export default {
    name: 'Term-page',
    data() {
        return {
            loading: true,
            reloadTerm: "",
        }
    },
    methods: {

    },
    created() {
        localStorage.setItem('reloadHome', 'false');
        localStorage.setItem('reloadCompanyProfile', 'false');
        localStorage.setItem('reloadRestore', 'false');
        localStorage.setItem('reloadRetal', 'false');
        localStorage.setItem('reloadGallers', 'false');
        localStorage.setItem('reloadBlog', 'false');
        localStorage.setItem('reloadPrivacy', 'false');

        this.reloadTerm = localStorage.getItem('reloadTerm');
        if (this.reloadTerm != 'true') {
            localStorage.setItem('reloadTerm', 'true');
        }
        if (localStorage.getItem('reloadTerm') == 'true') {
            setTimeout(() => {
                this.loading = false;
            }, 1000);
        }
    },
}
</script>

<style>
/* @import url('https://fonts.googleapis.com/css2?family=Battambang:wght@300;400&display=swap'); */
.term {
    padding-top: 150px;
    /* padding-bottom: 50px; */
    /* height: 100vh; */
}

.main_text {
    font-weight: 600;
    font-size: 14px;
    color: #1E1E1F;
}

.text_span {
    padding-bottom: 10px;
}

.text_span span {
    font-weight: 600;
    font-size: 36px;
    color: #1E1E1F;
}

.font-khmer {
    /* font-family: 'Battambang'; */
}

.above_text {
    font-size: 14px;
    font-weight: 400;
    color: #424245;
}

.text_font {
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 1.8;
}

.noted_img {
    /* width: 100%;
        height: 100%; */
    background: gainsboro;
}

.noted_img img {
    width: 100%;
    height: 100%;
}

.termpage {
    /* height: 170vh; */
    /* background-color: aqua; */
}

@media (width < 960px) {
    .term {
        padding-top: 95px;
    }

    .termpage {
        /* height: 300vh; */
        /* background-color: aqua; */
    }
}

@media (min-width: 960px) and (max-width: 1024px) {
    .termpage {
        /* height: 250vh; */
        /* background-color: aqua; */
    }
}

@media (min-width: 1024px) and (max-width: 1260px) {
    .termpage {
        /* height: 225vh; */
        /* background-color: aqua; */
    }
}

@media (min-width: 1260px) and (max-width: 1400px) {
    .termpage {
        /* height: 200vh; */
        /* background-color: aqua; */
    }
}
</style>